import parseHTML from "./lib/dom/funciones/parse_html";

const desplazadorDeGaleria = (galeria: HTMLElement, direccion: number) => {
    const elemento = galeria.querySelector<HTMLElement>('li:nth-child(2)')!;

    return () => galeria.scroll({
        left: galeria.scrollLeft + direccion * elemento.offsetLeft,
        behavior: 'smooth'
    });
};

const galeria = () => {
    const contenedores = Array.from(document.querySelectorAll<HTMLElement>('.bloque-salvador--galeria')),
        modal = document.querySelector<HTMLDialogElement>('#galeria-modal');

    if (contenedores.length === 0 || modal === null) {
        return;
    }

    const galerias = contenedores.map(tabla => tabla.querySelector('ul') as HTMLElement);
    const cerrarModal = modal.querySelector<HTMLElement>('.sv-galeria__modal__cerrar button');
    const contenidoModal = modal.querySelector<HTMLElement>('.sv-galeria__modal__contenido');

    if (!contenidoModal || !cerrarModal) {
        return;
    }

    cerrarModal.addEventListener('click', () => modal.close());
    modal.addEventListener('click', e => {
        if (e.target === modal) {
            modal.close();
        }
    });

    contenedores.forEach((hito, i) => {
        const anterior = parseHTML('<button class="sv-galeria__anterior" disabled>Anterior</button>') as HTMLButtonElement,
            siguiente = parseHTML('<button class="sv-galeria__siguiente">Siguiente</button>') as HTMLButtonElement,
            navegacion = parseHTML('<div class="sv-galeria__navegacion"></div>') as HTMLDivElement,
            botones = galerias[i].querySelectorAll('button');

        navegacion.appendChild(anterior);
        navegacion.appendChild(siguiente);
        hito.appendChild(navegacion);

        anterior.addEventListener('click', desplazadorDeGaleria(galerias[i], -1));
        siguiente.addEventListener('click', desplazadorDeGaleria(galerias[i], 1));

        const actualizaBotones = () => {
            anterior.disabled = galerias[i].scrollLeft === 0;
            siguiente.disabled = Math.abs(galerias[i].scrollLeft + galerias[i].clientWidth - galerias[i].scrollWidth) < 2;

            navegacion.style.display = anterior.disabled && siguiente.disabled ? 'none' : 'inline';
        };

        galerias[i].addEventListener('scroll', actualizaBotones);
        addEventListener('resize', actualizaBotones);
        actualizaBotones();

        botones.forEach(boton => {
            boton.addEventListener('click', () => {
                contenidoModal.innerHTML = boton.dataset.imagen || '';
                modal.showModal();
            });
        });
    });

    const ajustaScrolls = () => galerias.forEach((inner, i) => {
        if (inner.scrollWidth > inner.clientWidth) {
            contenedores[i].classList.add('is-scrollable');
        } else {
            contenedores[i].classList.remove('is-scrollable');
        }
    });

    addEventListener('resize', ajustaScrolls);
    addEventListener('load', ajustaScrolls);
    ajustaScrolls();
}

export default galeria;